/**
 * 判断 externalVideoLink 是否匹配指定的 Klarity Meet 域名
 * @param url - 视频链接地址
 * @returns 如果是 Klarity Meet 链接返回 true，否则返回 false
 */
export const isKlarityMeetLink = (url: string | undefined): boolean => {
    if (!url) return false;
    const allowedDomains = [
        'https://meeting.klarity-dev.boxpractice.com/',
        'https://meeting.klarity-test.boxpractice.com/',
        'https://meeting.helloklarity.com/',
        'https://meet.helloklarity.com',
    ];
    return allowedDomains.some((domain) => url.startsWith(domain));
};

